export default "__VITE_ASSET__Bk8CWfrF__"